import { render, staticRenderFns } from "./Pagination02.vue?vue&type=template&id=4d0a3784"
import script from "./Pagination02.vue?vue&type=script&lang=js"
export * from "./Pagination02.vue?vue&type=script&lang=js"
import style0 from "./Pagination02.vue?vue&type=style&index=0&id=4d0a3784&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports